/**
 * GA4 wiring (manual snippet). Only loaded when consent === "accepted" AND ga4_id is set.
 * Idempotent — multiple calls just no-op the load step.
 */
let _loaded = false;

export function loadGA4(measurementId) {
  if (_loaded || !measurementId) return;
  _loaded = true;
  // Inject gtag script
  const s = document.createElement("script");
  s.async = true;
  s.src = `https://www.googletagmanager.com/gtag/js?id=${measurementId}`;
  document.head.appendChild(s);
  // Inline bootstrap
  window.dataLayer = window.dataLayer || [];
  function gtag() { window.dataLayer.push(arguments); }
  window.gtag = gtag;
  gtag("js", new Date());
  gtag("config", measurementId, {
    anonymize_ip: true,
    allow_google_signals: false,
    allow_ad_personalization_signals: false,
  });
}

export function trackPageView(path) {
  if (typeof window.gtag !== "function") return;
  window.gtag("event", "page_view", { page_path: path });
}
